import { ChangeDetectionStrategy, Component, input } from '@angular/core';

import { TranslateModule } from '@ngx-translate/core';

import { getColorClassForWeatherIcon } from '../../../../helpers/weather-code-icon.helper';
import { IconComponent } from '../../../base-components/icon/icon.component';

export interface WeatherDay {
  name: string;
  icon: string;
  temperature: string;
  temperatureMin?: number;
  temperatureMax?: number;
}

export interface WeatherData {
  today: {
    condition: string;
    icon: string;
    temperature: string;
    temperatureMin: number;
    temperatureMax: number;
  };
  forecast: WeatherDay[];
}

@Component({
  selector: 'app-weather-menu',
  templateUrl: './weather-menu.component.html',
  styleUrls: ['./weather-menu.component.scss'],
  imports: [TranslateModule, IconComponent],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class WeatherMenuComponent {
  public data = input.required<WeatherData>();

  getWeatherIconColor(icon: string): string {
    return getColorClassForWeatherIcon(icon);
  }
}
